<template>
  <div class="tva-landing">
    <Header/>
    <main>
      <LandingIntro/>
      <!-- WHITE SECTION -->
      <section class="tva-numbers">
        <div class="tva-numbers-content">
          <div class="text-section">
            <h4
              v-html="$ml.get('landing').numbers_section.title"
            >{{$ml.get('landing').numbers_section.title}}</h4>

            <h5>{{$ml.get('landing').numbers_section.first_text}}</h5>
          </div>
          <div class="numbers-section">
            <div
              class="number-block"
              v-for="(number, index) in $ml.get('landing').numbers_section.sections"
              :key="index"
            >
              <div class="number">{{index+1}}</div>
              <svgicon :icon="number.img" height="55"></svgicon>
              <div class="text">
                <span class="number-text">{{number.number}}</span>
                <span class="chapter-text">{{number.title}}</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ChapterPreview :content="$ml.get('chapters')"></ChapterPreview>
    </main>
    <!-- <Footer/> -->
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import ChapterPreview from "../components/ChapterPreview.vue";
import LandingIntro from "../components/LandingIntro.vue";

export default {
  name: "Landing",
  mounted() {
    window.scrollTo(0, 0);
  },
  components: {
    Header,
    Footer,
    LandingIntro,
    ChapterPreview
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/fonts.scss";
@import "../assets/scss/colors.scss";
@import "../assets/scss/bootstrap-grid.scss";
@import "../assets/scss/buttons.scss";

.tva-landing {
  width: 100vw;
  .tva-numbers {
    width: 100vw;
    background: white;
    padding: 100px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    .tva-numbers-content {
      max-width: 820px;
      width: 800px;
      .text-section {
        display: flex;
        margin-bottom: 170px;
        h4 {
          width: 40%;
          padding-right: 50px;
        }
        h5 {
          width: 60%;
          border-left: solid 1px $eni-yellow;
          padding-left: 20px;
          margin: 0;
        }
      }
      .numbers-section {
        display: flex;

        .number-block {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: calc(100% / 3);
          position: relative;
          .number {
            color: rgba(155, 155, 155, 0.09);
            font-family: "Avenir Next";
            font-size: 230px;
            font-weight: 900;
            letter-spacing: 0.85px;
            line-height: 130px;
            width: 100px;
            position: absolute;
            bottom: 40px;
            left: calc(50% - 80px);
            margin: 0;
          }
          .number-text {
            border-right: solid 1px $eni-yellow;
            padding-right: 10px;
            margin-right: 10px;
          }
          .number-text,
          .chapter-text {
            font-family: "Avenir Next";
            font-size: 14px;
            font-weight: 800;
            font-style: normal;
            font-stretch: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: center;
            color: #4a4a4a;
            text-transform: uppercase;
          }
          .svg-icon {
            fill: none;
            stroke: black;
            width: 100px;
            margin-bottom: 14px;
            margin-left: 20px;
          }
        }
      }
    }
  }
}
@media (max-width: 1024px) {
  .tva-landing {
    .tva-numbers {
      .tva-numbers-content {
        padding: 0 50px;
        .text-section {
          flex-direction: column;
          h4,
          h5 {
            width: 100%;
          }
          h4 {
            margin-bottom: 30px;
          }
        }
      }
    }
  }
}
@media (max-width: 720px) {
  .tva-landing {
    .tva-numbers {
      padding: 50px 0;
      .tva-numbers-content {
        padding: 0 20px;
        width: 100%;

        .text-section {
          flex-direction: column;
          margin-bottom: 0;
          h4,
          h5 {
            width: 100%;
          }
          h4 {
            margin-bottom: 30px;
          }
        }
        .numbers-section {
          display: none;
        }
      }
    }
  }
}
</style>

